enum RegistryTypeEnum {
    BILLING_CON_FIRMAS = 1,
    HIS = 2,
}

export default RegistryTypeEnum;